import { gql, type TypedDocumentNode } from '@apollo/client';
import type { IActivities, ProviderActivitiesCountData, ProviderActivitiesVars } from './interfaces';


export const ACTIVITIES_QUERY: TypedDocumentNode<IActivities, ProviderActivitiesVars> = gql`
query ACTIVITIES_QUERY($providerId: Long!) {
    activities(providerId: $providerId) {
        client {
            firstName
            lastName
        }
        additionalParticipants {
            id 
            firstName,
            lastName,
            relationType,
            fullName,
            dateOfBirth
        }
        solutionCode
        activityId
        caseId
        targetedSystem {
            systemCode
        }
        activityStatusCode
    }
}
`

export const ACTIVITIES_COUNT_QUERY: TypedDocumentNode<ProviderActivitiesCountData, ProviderActivitiesVars> = gql`
    query ACTIVITIES_COUNT_QUERY($providerId: Long!) {
        activitiesCount(providerId: $providerId)
    }
`;
